import {ApolloError, FetchResult, gql, MutationTuple, useMutation} from '@apollo/client'
import {useAlert} from 'react-alert'
import {getGraphQLErrorMessage} from '~/util'
import {RenameOrganisation, RenameOrganisationVariables} from './__types__/RenameOrganisation'

export const RENAME_ORGANISATION = gql`
    mutation RenameOrganisation($idStr: String!, $name: String!) {
        updateOrganisation(organisationIdStr: $idStr, name: $name) {
            idStr
            name
        }
    }
`

export const useMutationRenameOrganisation = (): [
    MutationTuple<RenameOrganisation, RenameOrganisationVariables>,
    (
        organisationIdStr: string,
        name: string,
    ) => Promise<FetchResult<RenameOrganisation, Record<string, any>, Record<string, any>>>,
] => {
    const alert = useAlert()

    const mutation = useMutation<RenameOrganisation, RenameOrganisationVariables>(RENAME_ORGANISATION, {})
    const callMutation = async (organisationIdStr: string, name: string) => {
        try {
            const result = await mutation[0]({variables: {idStr: organisationIdStr, name}})
            alert.success(`Organisation successfully renamed to ${result.data?.updateOrganisation?.name}.`)
            return result
        } catch (error) {
            alert.error(getGraphQLErrorMessage(error as ApolloError))
            throw error
        }
    }
    return [mutation, callMutation]
}
